/* eslint-disable react/prop-types */

import { Chip } from "@mui/material";

export default function InfoChip({ icon, label }) {
    return (
        <Chip
            icon={icon}
            label={label}
            sx={{
                height: 34,
                borderRadius: 2.5,
                fontWeight: 900,
                color: "#334155",
                bgcolor: "#fff",
                border: "1px solid rgba(226,232,240,0.95)",
                "& .MuiChip-icon": {
                    color: "#0284c7",
                },
            }}
        />
    );
}